import axios from 'axios';

export default (getOptions) => ({
    Active: (id) => axios.post(`/api/incubator/session/pvt/active/${id}`, {}, getOptions()),
});
